const checkboxStyle = {
  "& .MuiSvgIcon-root": { fontSize: 28 },
  // color: "#0A4197",
  "&.Mui-checked": {
    color: "#0A4197",
  },
  padding: "0px",
};

const radioStyle = {
  "& .MuiSvgIcon-root": { fontSize: 28 },
  color: "#E0E0E0",
  "&.Mui-disabled": {
    color: 'rgba(0, 0, 0, 0.26)'
  },
  "&.Mui-checked": {
    color: "#0A4197",
    "&.Mui-disabled": {
      color: 'rgba(0, 0, 0, 0.26) !important'
    },
  },
  padding: "0px",
};

const globalStyle = { checkboxStyle, radioStyle };

export default globalStyle;
